import NetworkManage from "./manage"

export default NetworkManage
